import { addAllToRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { DeleteMessageFulfilledAction } from '../../../domains/deleteMessage/actions.types';
import {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../../domains/feedLoad/actions.types';
import {
  ThreadPinToGroupFeedFulfilledAction,
  ThreadUnpinFromGroupFeedFulfilledAction,
} from '../../../domains/pinnedThreads/actions.types';
import { ThreadMoveCompletedAction } from '../../../domains/threadMove/actions.types';
import { MessageDeletionOutcome } from '../../../normalization/types';
import {
  removeThreadFromAnyPinnedInstance,
  removeThreadFromAnyPinnedInstanceIfDeleted,
} from '../removeDeletedPinnedThread';
import { ThreadsPinnedToFeeds } from '../types';

export type ThreadsPinnedToGroupFeedsAction =
  | DeleteMessageFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | ThreadMoveCompletedAction
  | ThreadPinToGroupFeedFulfilledAction
  | ThreadUnpinFromGroupFeedFulfilledAction;

const initialState: ThreadsPinnedToFeeds = {};

const reducer: Reducer<ThreadsPinnedToFeeds, ThreadsPinnedToGroupFeedsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToGroupFeeds);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToGroupFeeds);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToGroupFeeds);
    case 'THREAD.PIN_TO_GROUP_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToGroupFeeds);
    case 'THREAD.UNPIN_FROM_GROUP_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToGroupFeeds);
    case 'MESSAGE.DELETE_FULFILLED':
      return removeThreadFromAnyPinnedInstanceIfDeleted(
        state,
        action.payload.threadId,
        action.payload.deletionOutcome === MessageDeletionOutcome.THREAD_REMOVED
      );
    case 'THREAD.MOVE_COMPLETED':
      return removeThreadFromAnyPinnedInstance(state, action.payload.threadId);
    default:
      return state;
  }
};

export default reducer;
